// Use environment variables for local development, fallback to window config for production
export const CONFIG: AppConfig = {
  httpLink:
    import.meta.env.VITE_HTTP_LINK ??
    window.__VENUS_CFG__?.httpLink ??
    "https://api.lytra.ai/graphql",
  wsLink:
    import.meta.env.VITE_WS_LINK ??
    window.__VENUS_CFG__?.wsLink ??
    "wss://api.lytra.ai/graphql",
  mercuryHttpLink:
    import.meta.env.VITE_MERCURY_HTTP_LINK ??
    window.__VENUS_CFG__?.mercuryHttpLink ??
    "https://api.lytra.ai/mercury/graphql",
  advascoHttpLink:
    import.meta.env.VITE_ADVASCO_HTTP_LINK ??
    window.__VENUS_CFG__?.advascoHttpLink ??
    "https://api.lytra.ai/advasco/graphql",
  customerWidgetUrl:
    import.meta.env.VITE_CUSTOMER_WIDGET_URL ??
    window.__VENUS_CFG__?.customerWidgetUrl ??
    "https://extension.lytra.ai/remote/widget/",
  oidcAuthority:
    import.meta.env.VITE_OIDC_AUTHORITY ??
    window.__VENUS_CFG__?.oidcAuthority ??
    "https://auth.lytra.ai/realms/lytra",
  oidcClientId:
    import.meta.env.VITE_OIDC_CLIENT_ID ??
    window.__VENUS_CFG__?.oidcClientId ??
    "venus",
  sentryEnvironment: window.__VENUS_CFG__?.sentryEnvironment,
  localDev: import.meta.env.DEV,
  // Number(undefined) is NaN, which ?? would not catch (only null/undefined);
  // || correctly falls through on both an unset/invalid env var and NaN.
  /* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
  agentSyncTimeoutMs:
    Number(import.meta.env.VITE_AGENT_SYNC_TIMEOUT_MS) ||
    window.__VENUS_CFG__?.agentSyncTimeoutMs ||
    35_000,
  /* eslint-enable @typescript-eslint/prefer-nullish-coalescing */
};
